import { apiCall } from './apiService';

/**
 * Fetch company posts with pagination.
 * @param {Object} opts
 * @param {number} opts.limit
 * @param {number} opts.offset
 * @returns {Promise<{items: Array, total: number, hasMore: boolean, offset: number, limit: number}>}
 */
export const fetchCompanyPosts = async ({ limit = 5, offset = 0 } = {}) => {
  const response = await apiCall(`/linkedin/posts?limit=${limit}&offset=${offset}`);
  return {
    items: response?.items || [],
    total: response?.total || 0,
    hasMore: response?.hasMore || false,
    offset: response?.offset ?? offset,
    limit: response?.limit ?? limit
  };
};

/**
 * Fetch the latest N posts (for the home page widget).
 */
export const fetchLatestPosts = async (count = 2) => {
  const response = await apiCall(`/linkedin/posts/latest?count=${count}`);
  return response?.items || [];
};

/**
 * Fetch organization-level stats (followers + aggregate engagement).
 */
export const fetchLinkedInStats = async () => {
  return apiCall('/linkedin/stats');
};

/**
 * Trigger an immediate sync (admin only).
 */
export const syncLinkedInPosts = async () => {
  return apiCall('/linkedin/sync', 'POST');
};
